import React from 'react';
import ButtonBase from './ButtonBase';
import { TButtonsDefault } from './types/TButtons';

const Tertiary = ({ as = 'button', ...rest }: TButtonsDefault) => <ButtonBase {...rest} as={as} kind="tertiary" />;

export default Tertiary;
